
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import 'react-dropdown-tree-select/dist/styles.css';
import MDBox from "components/MDBox";
import DashboardLayout from "layouts/LayoutContainers/DashboardLayout";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import axios from "axios";
import { useForm } from 'react-hook-form';
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { CircularProgress, Backdrop } from "@mui/material";
import Config from "../../config.js";
import { useTranslation } from "react-i18next";
import TreeSelect from '../../layouts/dashboardpages/TreeSelect';
import { handleErrors } from "common.js";
import { COLLECTION } from "constants.js";

function AddCollection(props) {

  const type = props.props.type;
  const navigate = useNavigate();
  const convertToTree = (data) => {
    let x = [];
    const treeData = [];
    data.forEach((node) => {
      if (node.children.length == 0) {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        treeData.push(tempArrayNew);
      }
      else {
        let tempArrayNew = {};
        tempArrayNew.label = node.name;
        tempArrayNew.value = node.id;
        tempArrayNew.children = convertToTree(node.children);
        treeData.push(tempArrayNew);
      }
    });
    return treeData;
  };

  const handleSelectSB = (selectedNode) => {
    setParentID(selectedNode.value);
    setValue('parentId', selectedNode.value);
    manipulateDataForDefaultSelected(collectionHierarchy, selectedNode.value);
    // Perform any desired actions with the selected node
  };

  const { id } = useParams();
  const { t } = useTranslation();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');
  const [collectionData, setCollectionData] = useState({});
  const [collectionHierarchy, setCollectionHierarchy] = useState([]);
  const [parentID, setParentID] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const { register, handleSubmit, setValue, setError, formState: { errors } } = useForm();

  const manipulateDataForDefaultSelected = (nodes, parentID) => {
    nodes.forEach((node) => {
      if (node.value == parentID) {
        node.checked = true;
        node.partialChecked = false;
      }
      if (node.children && node.children.length > 0) {
        manipulateDataForDefaultSelected(node.children, parentID);
      }
    });
  };

  const getHierarchy = (parentID) => {
    setIsLoading(true);
    axios({
      // Endpoint to send files
      url: BASE + "api/collection/getHierarchy/" + type,
      method: "GET",
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          const convertedData = convertToTree(response.data.data);
          setCollectionHierarchy(convertedData);
        }
        else {
          if (message != '')
            toast.error(t(message))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate((type == COLLECTION.PRODUCT) ? '/productcollection/list/' + parentID : (type == COLLECTION.SERVICE) ? '/servicecollection/list/' + parentID : null, { replace: true })
          }, 3000);
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
        const redirectTimeout = setTimeout(() => {
          clearTimeout(redirectTimeout);
          navigate((type == COLLECTION.PRODUCT) ? '/productcollection/list/' + parentID : (type == COLLECTION.SERVICE) ? '/servicecollection/list/' + parentID : null, { replace: true })
        }, 3000);
      }

    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };
  useEffect(() => {
    getHierarchy();
    setValue('parentId', 0);
  }, []);

  const onSubmit = async (data) => {
    setIsLoading(true);
    data.type = type;
    axios({
      // Endpoint to send files
      url: BASE + "api/collection/create",
      method: "POST",
      data: data,
      headers: {
        // Add any auth token here
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then(function (response) {
      setIsLoading(false);
      if (response.status == 200) {
        const status = response.data.status;
        const message = response.data.message;
        if (status == 1) {
          toast.success(t(message))
          const redirectTimeout = setTimeout(() => {
            clearTimeout(redirectTimeout);
            navigate((type == COLLECTION.PRODUCT) ? '/productcollection/list/' + parentID : (type == COLLECTION.SERVICE) ? '/servicecollection/list/' + parentID : null, { replace: true })
          }, 3000);
        }
        else {
          if (message != '')
            toast.error(t(message))
          if (response && response.data && response.data.errors) {
            const errorData = response.data.errors;
            errorData.forEach((error) => {
              setError(error.field, {
                type: 'server',
                message: t(error.errors[0])
              });
            });
          }
        }
      }
      else {
        toast.error(t('unableToProccessRequest'));
      }
    }).catch(function (error) {
      setIsLoading(false);
      handleErrors(error, t, navigate);
    });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={(type == COLLECTION.PRODUCT) ? t('add product collection') : (type == COLLECTION.SERVICE) ? t('add service collection') : null} />
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              {(collectionData) ?
                <MDBox component="form" role="form" onSubmit={handleSubmit(onSubmit)}>
                  <MDBox px={3}>
                    <Grid container spacing={2} mt={5}>
                      <Grid item xs={12} sm={3} md={3}>
                        <label className="labelCls">{t('collectionName')}<i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="name" label="" {...register("name", { required: true })} fullWidth />
                        {errors.name && errors.name.type === "required" && (
                          <p className="errorMsg">{t('Name is mandatory')}</p>
                        )}
                        {errors.name && (
                          <p className="errorMsg">{t(errors.name.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                        <label className="labelCls">{t('Select collection')}</label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        {(collectionHierarchy) ?
                          (<TreeSelect data={collectionHierarchy} onSelect={handleSelectSB} selected={parentID} />)
                          : null}
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                        <label className="labelCls">{t('handle')}<i className="mandatory">*</i></label>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDInput type="text" name="handle" label="" {...register("handle", { required: true })} fullWidth />
                        {errors.handle && errors.handle.type === "required" && (
                          <p className="errorMsg">{t('handleRequired')}</p>
                        )}
                        {errors.handle && (
                          <p className="errorMsg">{t(errors.handle.message)}</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={3} md={3}>
                      </Grid>
                      <Grid item xs={12} sm={7} md={7}>
                        <MDButton type="submit" variant="gradient" color="info" disableRipple>{t('Add')}</MDButton>
                      </Grid>
                    </Grid>
                  </MDBox>
                </MDBox>
                : null}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}
export default AddCollection;
